// utils/retryLogic/withRetry.ts - utils/retryLogic.ts split (sub-module withRetry)


import { RetryManager } from './manager.js';
import type {RetryOptions} from './types.js';


/**
 * Convenience function for simple use cases without status tracking
 */
export const withRetry = async <T>(
    operation: () => Promise<T>,
    options: RetryOptions = {}
): Promise<T> => {
    const manager = new RetryManager();
    return manager.execute(operation, options);
};
